import { useCallback, useEffect, useState } from "react";
import { capitalizeFirstLetter } from "../../../utils/transformString";

function useManageInput(inputName, validationConfig = {}) {
  const {
    required = false,
    minChar = null,
    maxChar = null,
    rule,
  } = validationConfig;

  const [value, setValue] = useState("");
  const [valueIsValid, setValueIsValid] = useState(false);
  const [error, setError] = useState(null);
  const [activeError, setActiveError] = useState(null);

  const checkValidity = useCallback(
    (liveValue, renderError = false) => {
      // priority 1
      if (required && (liveValue?.trim() || value?.trim()) == "") {
        setValueIsValid(false);

        if (!renderError) return;
        setError(`${capitalizeFirstLetter(inputName)} is required`);
        setActiveError("required");
        return false;
      }

      // priority 2
      if (minChar && (liveValue?.length || value?.length) < minChar) {
        setValueIsValid(false);

        if (!renderError) return;
        setError(`Must be at least ${minChar} characters`);
        setActiveError("minChar");
        return false;
      }

      // priority 3
      if (
        rule &&
        (((liveValue != null || undefined) &&
          rule?.regex.test(liveValue) == false) ||
          !rule?.regex.test(value))
      ) {
        setValueIsValid(false);

        if (!renderError) return;
        setError(rule?.message);
        setActiveError("rule");
        return false;
      }

      setValueIsValid(true);
      setError(null);
      setActiveError(null);
      return true;
    },
    [value, required, minChar, maxChar, rule]
  );

  const resolveActiveError = useCallback(
    (liveValue) => {
      const solveError = () => {
        setError(null);
        setActiveError(null);
      };

      if (
        activeError == "required" &&
        (liveValue?.trim() || value?.trim()) != ""
      )
        solveError();

      if (
        activeError == "rule" &&
        (((liveValue != null || undefined) &&
          rule?.regex.test(liveValue) == true) ||
          rule?.regex.test(value))
      ) {
        solveError();
      }

      if (
        activeError == "minChar" &&
        (liveValue?.length || value?.length) >= minChar
      )
        solveError();
    },
    [activeError, value, rule, minChar]
  );

  useEffect(() => {
    checkValidity();
  }, [value]);

  useEffect(() => {
    if (!error) return;
    resolveActiveError();
  }, [value, error]);

  const showError = (liveValue) => {
    checkValidity(liveValue, true);
  };

  return {
    value,
    valueIsValid,
    error,
    setValue,
    setError,
    showError,
  };
}

export default useManageInput;

// const rules = {
//   required(name) {
//     return {
//       regex: /.+/,
//       message: `${name} is required.`,
//     };
//   },
//   name: {
//     regex: /^[a-zA-Z\s]+$/,
//     message: "Only alphabets and spaces are allowed.",
//   },
//   email: {
//     regex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
//     message: "Invalid email",
//   },
//   minChar(n) {
//     const regex = new RegExp(`^.{${n},}$`);
//     return {
//       regex,
//       message: `Must be at least ${n} characters.`,
//     };
//   },
//   maxChar(n) {
//     const regex = new RegExp(`^.{${n},}$`);
//     return {
//       regex,
//       message: `Maximum only ${n} characters allowed`,
//     };
//   },
// };
